import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  Input,
  Button,
  InputGroup
} from 'reactstrap'

class ServicesCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      services: props.cardFields[0].fieldValue
    }

    this.fixedServices = [
      'Finanzierungsberatung',
      'Individuelle Planung',
      'Grundstücksvermittlung',
      'Blower-Door-Test',
      'Preisgarantie',
      'Bauzeitgarantie',
      'Architektenberatung',
      'Übernahme Hausanschlüsse',
      'Baustellenkoordination',
      'Einrichtungsberatung',
      'Finanzierungsvermittlung',
      'Koordination mit Bauamt',
      'Energieeffizienzberatung',
      'Grundstücksgutachten',
      'Beratung preisbewusstes Bauen'
    ]

    this.returnValue = this.returnValue.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.handleAddNewService = this.handleAddNewService.bind(this)
    this.handleDeleteService = this.handleDeleteService.bind(this)
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      services: newProps.cardFields[0].fieldValue
    })
  }

  returnValue(value) {
    return this.state.services
  }

  handleSelectChange(ev) {
    let services = new Set(this.state.services)
    let checkbox = ev.target

    if (checkbox.checked) {
      services.add(checkbox.value)
    } else {
      services.delete(checkbox.value)
    }

    this.setState({
      services: [...services]
    })
  }

  handleAddNewService(ev) {
    ev.preventDefault()

    if (this.addServiceField.value) {
      let newValue = this.addServiceField.value
      this.setState(prevState => {
        return {
          services: prevState.services.indexOf(newValue) < 0 ?
                    prevState.services.concat(newValue) :
                    prevState.services
        }
      })

      this.addServiceField.value = ""
    }
  }

  handleDeleteService(ev, service) {
    ev.preventDefault()

    this.setState(prevState => {
      return {
        services: prevState.services.filter(el => el !== service)
      }
    })
  }

  render() {
    const extraServices = this.state.services
                            .filter(el => this.fixedServices.indexOf(el) < 0)
                            .map((el, index) => {
                              return [
                                  index === 0 ? <label key="fixed-services-label">Zusätzliche Services</label> : null,
                                  <div key={`extra-services-${index}`} className="mb-3">
                                    <Button size="sm" color="danger" onClick={(ev) => this.handleDeleteService(ev, el)}><i className="icon-trash"></i></Button> {el}
                                  </div>
                                ]
                            })

    return this.props.isEditing || this.props.cardType === 'always-on' ?
      <div className="card-field mb-3">
        <Label>Häufige Services</Label>
        <InputGroup key={`fixed-services-wrapper`} className="mb-3 d-sm-block">
        {
          this.fixedServices.map((el, index) =>  {
            return (
              <Label key={`checkbox-${el}`} className="d-sm-block ml-4">
                <Input
                  type="checkbox"
                  key={`fixed-services-${index}`}
                  name="fixed-services"
                  value={el}
                  defaultChecked={this.state.services.indexOf(el) > -1}
                  onChange={this.handleSelectChange}
                  innerRef={el => { this[`fixed-services-${el}`] = el }}
                />{' '}
                {el}
              </Label>
            )
          })
        }
        </InputGroup>
        {extraServices}
        <p>Gibt es weitere Services die Sie auszeichnen? Dann ergänzen Sie dieses hier.</p>
        <InputGroup>
          <Input type="text" name="new-service" innerRef={el => { this.addServiceField = el }} />
          <Button color="primary" size="sm" type="submit" onClick={this.handleAddNewService}><i className="icon-plus"></i> Service hinzufügen</Button>
        </InputGroup>
      </div>
    :
      <div className="mb-3">
        {this.props.cardFields[0].fieldValue.map((el, index) => {
          return <div key={`services-list-${index}`} className="mb-1"><i className="icon-check"></i> {el}</div>
        })}
      </div>
  }
}

ServicesCard.propTypes = {
  cardFields: PropTypes.array,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

export default ServicesCard


// WEBPACK FOOTER //
// ./src/components/EditableCard/ServicesCard.js